var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrowRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.438,
    fill: "#48BB78",
    r: 5.786
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.267,
    cy: 8.5,
    r: 6.5,
    transform: "rotate(-56 9.267 8.5)",
    fill: "#F56565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.55 8.652a8.717 8.717 0 018.565-8.87 8.717 8.717 0 018.87 8.566 8.717 8.717 0 01-8.566 8.87A8.717 8.717 0 01.55 8.651zm5.065.928l2.499-2.698.112 6.418c.008.468.39.837.858.829l.563-.01a.842.842 0 00.829-.858l-.113-6.419 2.592 2.61a.845.845 0 001.206-.007l.376-.394a.84.84 0 00-.02-1.191L9.773 3.277a.84.84 0 00-1.192.02L4 8.043a.84.84 0 00.02 1.192l.39.38a.845.845 0 001.206-.035z",
    fill: "#FED7D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowRed);
export default __webpack_public_path__ + "static/media/up-arrow-red.bb161f04f8f0b8737d686766f49ea716.svg";
export { ForwardRef as ReactComponent };